import React, {
  ComponentType
} from 'react'
import { Image } from 'semantic-ui-react'
import { connect } from 'react-redux'
// Local
import * as config from '../../../config'
import { API_URL } from '../../../constant'
import { useCdiRestricted } from '../../common/roleUtils'
import { User } from '../../authenticated/types'
import { RootState } from '../../../store'

const SafeImage = Image as unknown as ComponentType<any>

type PatientProfileOwnProps = {
  patientId: string
  clazz?: string
}

type PatientProfileReduxProps = {
  currentUser: User
}

type PatientProfileProps = PatientProfileOwnProps & PatientProfileReduxProps

/**
 * @param patientId Patient ID
 * @param clazz Optional class name to apply to image
 */
function PatientProfile(props: PatientProfileProps): JSX.Element {
  const {
    patientId,
    clazz,
    currentUser
  } = props
  const effectiveRole = useCdiRestricted(currentUser)
  return (
    <SafeImage
      src={ `${config.BASE_URL}${API_URL.PATIENT_PROFILE_WITH_ROLE(effectiveRole)}${patientId}` }
      className={ clazz || '' }
    />
  )
}

const ConnectedPatientProfile = connect(
  (state: RootState) => ({
    currentUser: state.user
  })
)(PatientProfile)

export default ConnectedPatientProfile as React.ComponentType<PatientProfileOwnProps>
